import React, { forwardRef, useImperativeHandle } from 'react';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { redirectToUsers } from '../../../../utils/appointments/redirect-utils';
import ActionConfirmation from '../../../common/ActionConfirmation';
import { useToggleFlag } from '../../../../hocs/useToogleFlag';
import styles from './styles.styl';

function LeaveFlowModal({ formatMessage, clearProgressConsents }, ref) {
  const [opened, openConfirm, closeConfirm] = useToggleFlag();

  useImperativeHandle(ref, () => ({
    open: openConfirm,
  }));

  const handleSubmit = () => {
    clearProgressConsents();
    redirectToUsers();
  };

  return (
    <ActionConfirmation
      danger={false}
      opened={opened}
      onClose={closeConfirm}
      onSubmit={handleSubmit}
      title={formatMessage({ id: 'appointments.confirmModalTitle' })}
      content={
        <div styleName="modal-body">
          {formatMessage({ id: 'appointments.confirmModalText' })}
        </div>
      }
      actionButtonText={formatMessage({
        id: 'appointments.confirmLeaveMessage',
      })}
    />
  );
}

LeaveFlowModal.propTypes = {
  formatMessage: PropTypes.func,
  clearProgressConsents: PropTypes.func,
};

const LeaveFlowModalWithStyles = CSSModules(LeaveFlowModal, styles, {
  allowMultiple: true,
});

const LeaveFlowModalWithRef = forwardRef(LeaveFlowModalWithStyles);

LeaveFlowModalWithRef.propTypes = {
  formatMessage: PropTypes.func,
  clearProgressConsents: PropTypes.func,
};

export default LeaveFlowModalWithRef;



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/Components/LeaveFlowModal/index.jsx